import { render, staticRenderFns } from "./EmergencyProcedures.vue?vue&type=template&id=0e1a837a&scoped=true"
import script from "./EmergencyProcedures.vue?vue&type=script&lang=js"
export * from "./EmergencyProcedures.vue?vue&type=script&lang=js"
import style0 from "./EmergencyProcedures.vue?vue&type=style&index=0&id=0e1a837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a837a",
  null
  
)

export default component.exports